import { Button, Stack, Typography } from '@mui/material';

// Components
import { useTranslation } from 'react-i18next';
import ModalComponent from 'src/components/Modal/ModalComponent';

interface IProps {
  open: boolean;
  handleClose: () => void;
  handleConfirm: () => void;
}

export enum TradeDataSearchBy {
  HS_CODE = 'hs_code',
  HS_CODE_AI = 'hs_code_ai',
}

const FormWarningQuit = (props: IProps) => {
  const { handleConfirm, handleClose, open } = props;
  const { t } = useTranslation();

  return (
    <ModalComponent padding={4} handleClose={handleClose} open={open}>
      <Stack flexDirection={'column'} justifyContent={'center'} alignItems={'center'} gap={1} width={540}>
        <Stack flexDirection={'column'} spacing={2}>
          <Typography textAlign={'center'} variant="h5">
            Processing Your Payment
          </Typography>
          <Typography textAlign="center" variant="body1" color="text.secondary">
            Please stay on this page while we complete your transaction. It should only take a moment.
          </Typography>
          <Stack direction="row" spacing={2}>
            <Button variant="outlined" color="inherit" onClick={() => handleConfirm()} fullWidth>
              Leave Page
            </Button>
            <Button variant="contained" color="primary" onClick={() => handleClose()} fullWidth>
              Stay here
            </Button>
          </Stack>
        </Stack>
      </Stack>
    </ModalComponent>
  );
};

export default FormWarningQuit;
